// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fCsm","footer":"Header_footer__3TlQ7","logo":"Header_logo__2gAbO","currentRoute":"Header_currentRoute__aDIVV","hLine":"Header_hLine__SZHuV"};